import * as actionTypes from "../actions/actionTypes";

const initialState = {
  searchInput: ""
};

const updateSearch = (state, action) => {
  return { ...state, searchInput: action.str };
};

const deleteSearch = (state, action) => {
  return { ...state, searchInput: "" };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SEARCH_STRING:
      return updateSearch(state, action);
    case actionTypes.DELETE_SEARCH_STRING:
      return deleteSearch(state, action);
    default:
      return state;
  }
};

export default reducer;
